var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.mTags),function(tag,idx){return _c('span',{key:idx,staticClass:"badge badge-light-blue letter"},[_vm._v("# "+_vm._s(tag))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }